import { Login } from "../pages";
import FrappeLogin from "../pages/FrappeLogin";

export default function route() {
  return [
    {
      path: "/",
      name: "Login",
      key: "/",
      private: false,
      element: <Login />,
    },
    {
      path: "/frappe-login",
      name: "Frappe Login",
      key: "/frappe-login",
      private: false,
      element: <FrappeLogin />,
    },
  ];
}
